export interface IRank {
  broadcast_name: string
  country_code: string
  date: string
  driver_number: number
  first_name: string
  full_name: string
  headshot_url: string
  last_name: string
  meeting_key: number
  name_acronym: string
  position: number
  session_key: number
  team_colour: string
  team_name: string
  duration: string
}
export class RankDTO {
  broadcast_name: string
  country_code: string
  date: string
  driver_number: number
  first_name: string
  full_name: string
  headshot_url: string
  last_name: string
  meeting_key: number
  name_acronym: string
  position: number
  session_key: number
  team_colour: string
  team_name: string
  duration: string
  constructor(data: IRank) {
    this.broadcast_name = data.broadcast_name
    this.country_code = data.country_code
    this.date = data.date
    this.driver_number = data.driver_number
    this.first_name = data.first_name
    this.full_name = data.full_name
    this.headshot_url = data.headshot_url
    this.last_name = data.last_name
    this.meeting_key = data.meeting_key
    this.name_acronym = data.name_acronym
    this.position = data.position
    this.session_key = data.session_key
    this.team_colour = data.team_colour
    this.team_name = data.team_name
    this.duration = data.duration
  }
}
